import { render } from "./User.vue?vue&type=template&id=e6d648e2"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"

import "./User.vue?vue&type=style&index=0&id=e6d648e2&lang=less"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\wxPrint2\\adminVue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__